import { request } from "../../../lib/requestHelper";

export const fetchMessagesApi = async(conversationId) =>{
    return await request(`chat/get-messages/${conversationId}`, {
        method: "GET"
    });
}

export const fetchConversationsApi = async() => {
    return await request('chat/get-conversations', {
        method: "GET"
    });
}

export const createConversationApi = async(otherUserId) => {
    return await request('chat/create-conversation', {
        method: 'POST',
        body: JSON.stringify({ otherUserId })
    });
}

export const sendMessageApi = async (conversationId, content, messageType = 'text') => {
    return await request(`chat/send-message/${conversationId}`, {
        method: 'POST',
        body: JSON.stringify({ content, messageType })
    });
};

export const fetchUnreadCountApi = async () => {
    return await request('chat/unread-count');
}

export const getBookingByIdApi = async (bookingId) => {
    return await request(`artisan/get-project/${bookingId}`);
};

export const acceptBookingApi = async (bookingId) => {
    return await request(`artisan/accept-booking/${bookingId}`, {
        method: "PUT"
    });
};

export const getBookingByBidIdApi = async (bidId) => {
    return await request(`artisan/get-booking-by-bid/${bidId}`);
};